import React from "react";
import Grid from "@material-ui/core/Grid";
import { GridRegisterNormal } from "./GridRegisterNormal";
import { GridRegisterServiceProvider } from "./GridRegisterServiceProvider";
import { GridRegisterTenant } from "./GridRegisterTenant";
import { GridRegisterVisitant } from "./GridRegisterVisitant";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import Styles from "../styles";
import { Person, Visibility } from "@material-ui/icons";
import ButtonMenu from "../../../components/buttons/ButtonMenu";
import { customModal } from "../../../components/modals/utils";
import { Select } from "../../../components/inputs/newForm";

export interface IModalRegister {
    oldData?: any;
    optionsProfiles?: { value: string; label: string }[];
    edit?: boolean;
    placeList?: any[];
    serviceProviderList?: any[];
    reload: (data: any) => void;
}

const modalSchema = z.object({
    profile: z.string().min(1, "*Campo Obrigatório"),
});

type ModalFormData = z.infer<typeof modalSchema>;

export function ModalRegister(props) {
    const {
        oldData,
        optionsProfiles,
        edit,
        placeList,
        serviceProviderList,
        reload,
    }: IModalRegister = props;

    const { control, watch } = useForm<ModalFormData>({
        resolver: zodResolver(modalSchema),
        defaultValues: {
            profile: oldData?.subType || oldData?.type || "",
        },
    });

    const selectedProfile = watch("profile");

    const [displayedFacial, setDisplayedFacial] = React.useState<any>(null);
    const [showFacial, setShowFacial] = React.useState(false);

    function handleShowFacial(facialUrl: any, cleanFacial: boolean) {
        if (cleanFacial) {
            setDisplayedFacial(null);
            setShowFacial(false);
            return;
        }
        setShowFacial(!showFacial);
        setDisplayedFacial(facialUrl);
    }

    const getButtons = (itemGuest: any, fullItem: any) => {
        if (!itemGuest) return [];

        if (!itemGuest.imageId) {
            return [
                {
                    label: "Tirar Foto",
                    onClick: () => {
                        customModal.setInfos(
                            "Assinatura Facial",
                            [itemGuest?.facialUrl || ""],
                            { onClick: () => customModal.close(), label: "Voltar" },
                            null,
                            null,
                            false,
                            true,
                            <Visibility />
                        );
                    },
                },
            ];
        }

        return [
            {
                label: "Visualizar",
                onClick: () => {
                    customModal.setInfos(
                        "Link da Imagem",
                        [itemGuest?.facialUrl || ""],
                        { onClick: () => customModal.close(), label: "Voltar" },
                        null,
                        null,
                        false,
                        true,
                        <Visibility />
                    );
                },
            },
        ];
    };

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                minWidth: "clamp(300px, 54vw, 1055px)",
                padding: "25px",
            }}
        >
            <Grid container spacing={2} style={{ width: "100%" }} alignItems="flex-start">
                {!edit && showFacial && (
                    <Grid item xs={12} md={12} lg={2}>
                        <Styles.ImageLabel>Assinatura Facial</Styles.ImageLabel>
                        <Styles.ImageBox>
                            {displayedFacial &&
                                (displayedFacial.imageId || displayedFacial.facialUrl) ? (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    {displayedFacial?.facialUrl ? (
                                        <div
                                            style={{
                                                borderRadius: "8px",
                                                height: "100%",
                                                width: "100%",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "center",
                                                backgroundSize: "cover",
                                                backgroundImage: `url(${displayedFacial.facialUrl})`,
                                            }}
                                        />
                                    ) : null}
                                    <div style={{ position: "absolute", bottom: 8, right: 8 }}>
                                        <ButtonMenu
                                            endIcon={<Visibility />}
                                            buttons={getButtons(displayedFacial, oldData)}
                                        >
                                            Visualizar
                                        </ButtonMenu>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "100%",
                                        position: "relative",
                                    }}
                                >
                                    <Person style={{ fontSize: 130, color: "#9e9e9e" }} />
                                </div>
                            )}
                        </Styles.ImageBox>
                    </Grid>
                )}
                <Grid
                    item
                    xs={12}
                    md={12}
                    lg={showFacial ? 10 : 12}
                    className="inputs-grid"
                >
                    <Grid
                        container
                        spacing={3}
                        alignItems="flex-start"
                        style={{ width: "100%" }}
                    >
                        <Grid item xs={12} md={12} lg={3}>
                            <Select
                                control={control}
                                name="profile"
                                label="Perfil"
                                labelStyles="5px"
                                readOnly={edit}
                                defaultValue={
                                    optionsProfiles?.find((p) => p.value === (oldData?.subType || oldData?.type))
                                        ?.value ?? ""
                                }
                                options={optionsProfiles ?? []}
                                onChangeCustom={() => {
                                    setShowFacial(false);
                                    setDisplayedFacial(null);
                                }}
                            />
                        </Grid>

                        {(() => {
                            const normalPlaceList = (placeList ?? []).filter((p: any) => p.type === "NORMAL");
                            return (<>
                        {selectedProfile === "NORMAL" && (
                            <GridRegisterNormal
                                edit={edit}
                                oldData={oldData}
                                placeList={normalPlaceList}
                                onImageUrlFetch={handleShowFacial}
                                reload={reload}
                            />
                        )}
                        {selectedProfile === "SERVICE_PROVIDER" && (
                            <GridRegisterServiceProvider
                                edit={edit}
                                oldData={oldData}
                                placeList={normalPlaceList}
                                serviceProviderList={serviceProviderList}
                                onImageUrlFetch={handleShowFacial}
                                reload={reload}
                            />
                        )}
                        {selectedProfile === "TENANT" && (
                            <GridRegisterTenant
                                edit={edit}
                                oldData={oldData}
                                placeList={normalPlaceList}
                                onImageUrlFetch={handleShowFacial}
                                reload={reload}
                            />
                        )}
                        {selectedProfile === "VISITANT" && (
                            <GridRegisterVisitant
                                edit={edit}
                                oldData={oldData}
                                placeList={normalPlaceList}
                                onImageUrlFetch={handleShowFacial}
                                reload={reload}
                            />
                        )}
                            </>);
                        })()}
                    </Grid>
                </Grid>
            </Grid>
            {!selectedProfile && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        marginTop: "20px",
                    }}
                >
                    <Styles.CancelButton
                        onClick={() => customModal.close()}
                        fullWidth={false}
                    >
                        Cancelar
                    </Styles.CancelButton>
                </div>
            )}
        </div>
    );
}
